module.exports = __webpack_public_path__ + "static/theresa-o-27c0aa613ac0379bbb58dd4d5c4460e1.jpg";